import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SharedPagination from "../../modules/common/sharedPagination";
import "./style.css";
import { CommonTable } from "../../modules/common/table/Table";
import { ClearAllNotification, GetNotifications } from "../../redux/features/notifications/notificationActions";
import { notificationListColumns } from "../../modules/common/table/columns/_notificationListColumns";
import { conFirmMessage } from "../../utlis/shared";

const NotificationsPage = () => {
  const dispatch: any = useDispatch();
  const [loading, setLoading] = useState(true);
  const headers = ["name", "sku", "consumedQuantity", "updatedAt"];
  const [currentPage, setCurrentPage] = useState(1);
  const limit = 10;
  const states = useSelector((state: any) => state.notificationsSlice);
  const notificationsList = states?.notifications || [];
  const totalRecord = states?.totalRecord || 0;
  const totalPages = Math.ceil(totalRecord / limit);


  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        await dispatch(GetNotifications({ page: currentPage, limit }));
      } catch (error) {
        console.error("Failed to fetch notifications:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchNotifications();
  }, [currentPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleClearAllNotification = async () => {
    const values = {
      title: "Sei sicuro?",
      text: "Non potrai annullare questa operazione!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sì, cancella tutto!",
      cancelButtonText: "Annulla",
    };

    const result = await conFirmMessage(values);

    if (result.isConfirmed) {
      dispatch(ClearAllNotification());
    }
  };


  return (
    <>
      <div className="order-status-container">
        <div className='notificationTitle'>
          <h2 className="page-title">Notifiche</h2>
          <button
            className='cancellAllBtn'
            onClick={handleClearAllNotification}
            disabled={notificationsList?.length === 0}
          >
            Cancella tutto
          </button>
        </div>

        <div className='orderListTable'>
          {loading ? (
            <p className="loading-text">Caricamento notifiche...</p>
          ) : notificationsList?.length > 0 ? (
            <CommonTable data={notificationsList} columns={notificationListColumns} />
          ) : (
            <p className="no-orders">Nessuna notifica disponibile</p>
          )}
        </div>

        {totalRecord > 10 && <SharedPagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />}

      </div>
    </>
  );
};

export default NotificationsPage;
